import React, { Component } from "react";

// TODO : improve SEO https://support.google.com/webmasters/answer/7451184?hl=fr

import {
  Header,
  Drawer,
  Project,
  Landing,
  Projects,
  Footer
} from "./components";

import { withRouter, Route, Switch } from "react-router-dom";

import { ParallaxProvider } from "react-scroll-parallax";

import "./App.scss";

import { TopAppBarFixedAdjust } from "@material/react-top-app-bar";

import Contact from "./components/Contact/Contact";
import Credits from "./components/Credits/Credits";

import { animateScroll as scroll } from "react-scroll";

const ScrollToTop = () => {
  scroll.scrollToTop({
    delay: 0,
    smooth: "easeInOutQuint"
  });
  return null;
};

const projects = require("./data");

class App extends Component {
  state = {
    // selectedIndex: 0,
    drawerOpen: false,
    creditsOpen: false
  };

  toggleDrawer = () => {
    this.setState({ drawerOpen: !this.state.drawerOpen });
  };

  closeDrawer = () => {
    this.setState({ drawerOpen: false });
  };

  render() {
    const { drawerOpen } = this.state;

    return (
      <ParallaxProvider>
        <Header toggleDrawer={this.toggleDrawer} />

        <Drawer drawerOpen={drawerOpen} closeDrawer={this.closeDrawer} />

        <TopAppBarFixedAdjust>
          <Route component={ScrollToTop} />
          <Switch>
            <Route exact path="/contact" component={Contact} />
            <Route exact path="/credits" component={Credits} />
            <Route
              exact
              path="/p/:projectSlug"
              render={({ match }) => (
                <Project
                  project={projects.find(
                    p => p.slug === match.params.projectSlug
                  )}
                />
              )}
            />
            <Route
              exact
              path="/"
              render={() => (
                <div className="content">
                  <Landing />
                  <Projects projects={projects} />
                </div>
              )}
            />
          </Switch>
        </TopAppBarFixedAdjust>

        <Footer />
      </ParallaxProvider>
    );
  }
}

export default withRouter(App);
